import React from "react";
import Banner from "../Components/Banner";

const policies = [
  {
    title: "1. Introduction",
    text: "This Refund and Cancellation Policy outlines the terms under which HNH Soft Tech Solutions Pvt Ltd provides refunds or accepts project cancellations for digital services.",
  },
  {
    title: "2. Nature of Services",
    text: "All services provided by HNH Soft Tech Solutions Pvt Ltd are custom digital services including website development, mobile application development, UI/UX design, and digital marketing solutions.",
  },
  {
    title: "3. Project-Based Work",
    text: "Due to the custom nature of software development services, refunds are generally not available once development work has started or project deliverables have been shared with the client.",
  },
  {
    title: "4. Milestone Payments",
    text: "Many projects are divided into milestones. If a project is cancelled before a milestone begins, a partial refund may be considered depending on the work already completed.",
  },
  {
    title: "5. Consultation Services",
    text: "Consultation or hourly technical services are non-refundable once the consultation session has been completed.",
  },
  {
    title: "6. Client Responsibilities",
    text: "Clients are responsible for providing accurate project requirements and timely feedback. Delays caused by missing client input may affect refund eligibility.",
  },
  {
    title: "7. Cancellation Requests",
    text: "Cancellation requests must be submitted in writing via email. Each request will be reviewed based on the current stage of the project.",
  },
  {
    title: "8. Processing Refunds",
    text: "If a refund is approved, it will be processed using the original payment method within a reasonable timeframe.",
  },
  {
    title: "9. Policy Updates",
    text: "HNH Soft Tech Solutions Pvt Ltd reserves the right to update or modify this Refund Policy at any time. Updates will be published on this page.",
  },
  {
    title: "10. Contact Information",
    text: "For refund or cancellation inquiries, please contact us at info@hnhsofttechsolutions.com.",
  },
];

const RefundPolicy = () => {
  return (
    <>
      <Banner
        heading="Refund, Return & Cancellation Policy"
        text="Refund Policy"
      />

      <section className="py-20 px-4 bg-gray-50 font-sans">
        <div className="px-20">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-[#025383] mb-4">Refund Policy</h2>
            <p className="text-gray-800 text-center text-xl">Please read our refund and cancellation policies carefully before engaging with our services.</p>
          </div>

          <div className="space-y-6">
            {policies.map((item, index) => (
              <div
                key={index}
                className="bg-white border-l-[6px] border-[#025383] rounded-2xl p-6 sm:p-8 shadow-[0_4px_20px_rgba(0,0,0,0.04)] hover:shadow-[0_4px_25px_rgba(2,83,131,0.12)] transition-all duration-300"
              >
                <div className="flex items-center gap-4 mb-4">
                  <div className="flex-shrink-0 w-12 h-12 rounded-full bg-[#025383]/10 flex items-center justify-center text-[#025383] text-xl font-bold">
                    {index + 1}
                  </div>
                  <h3 className="text-[#025383] text-2xl font-bold">
                    {item.title.replace(/^\d+\.\s*/, '')}
                  </h3>
                </div>
                <p className="text-gray-700 leading-relaxed text-[17px] sm:pl-16">
                  {item.text}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default RefundPolicy;